<template>
  <div class="container mx-auto px-4 py-16 max-w-5xl">
    <!-- Breadcrumb -->
    <nav class="text-gray-600 text-sm mb-4">
      <router-link
        to="/"
        class="hover:text-blue-600 transition"
      >
        Home
      </router-link> › 
      <span class="text-gray-700">About</span>
    </nav>

    <!-- Header Section -->
    <div class="text-center mb-16">
      <h1 class="text-2xl font-bold mb-2">
        About Us
      </h1>
      <p class="text-xl text-blue-600">
        We are a small passionate team.
      </p>
    </div>

    <!-- Mission Section -->
    <div class="mb-16 text-center">
      <h2 class="text-3xl font-bold text-gray-800 mb-4">
        Empowering the world with Crypto.
      </h2>
      <p class="text-lg text-gray-600 max-w-4xl mx-auto">
        We are a team with extensive experience in the cryptocurrency space. Our journey in crypto has equipped us with deep insights into blockchain technology, decentralized finance (DeFi), and digital asset management.
      </p>
    </div>

    <!-- Team Members Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
      <div 
        v-for="member in team" 
        :key="member.name" 
        class="bg-blue-50 border border-blue-100 rounded-xl p-6 text-center text-gray-700 transition-all hover:bg-blue-100"
      >
        <!-- Profile Picture -->
        <img 
          :src="member.image" 
          :alt="member.name" 
          class="rounded-full w-32 h-32 mx-auto mb-4 object-cover"
        >
        
        <!-- Name & Position -->
        <h3 class="text-xl font-bold">
          {{ member.name }}
        </h3>
        <p class="text-blue-600">
          {{ member.position }}
        </p>

        <!-- Social Media Icons -->
        <div class="flex justify-center space-x-4 mt-4">
          <a
            v-if="member.telegram"
            :href="member.telegram"
            target="_blank"
            class="text-blue-600 hover:text-blue-700 transition"
          >
            <i class="fab fa-telegram text-2xl" />
          </a>
          <a
            v-if="member.twitter"
            :href="member.twitter"
            target="_blank"
            class="text-blue-600 hover:text-blue-700 transition"
          >
            <i class="fab fa-twitter text-2xl" />
          </a>
          <a
            v-if="member.youtube"
            :href="member.youtube"
            target="_blank"
            class="text-blue-600 hover:text-blue-700 transition"
          >
            <i class="fab fa-youtube text-2xl" />
          </a>
          <a
            v-if="member.github"
            :href="member.github"
            target="_blank"
            class="text-blue-600 hover:text-blue-700 transition"
          >
            <i class="fab fa-github text-2xl" />
          </a>
        </div>

        <!-- Experience Description -->
        <p class="text-gray-600 mt-4 text-sm">
          {{ member.experience }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutComponent',
  data() {
  return {
    team: [
      {
        name: 'Winnodex',
        position: 'Founder & Software Developer',
        image: require('@/assets/image-team/win.png'),
        telegram: 'https://t.me/Winnodexx',
        twitter: 'https://x.com/WinNode',
        youtube: '',
        github: 'https://github.com/winnode',
        experience: 'Passionate about building innovative and scalable solutions. Experienced in coding, system architecture, and software development for blockchain and web applications.'
      }
    ]
  };
}
}
</script>

<style scoped>
/* Hover effect for icons */
a:hover {
  text-decoration: none;
}
</style>